var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center white rounded-lg pa-4"},[_c('app-text',{attrs:{"color":"primary","size":"xlarge-bold"}},[_vm._v(_vm._s(_vm.usersData.length))]),_c('app-text',{staticClass:"mt-4"},[_vm._v("User accounts Pending")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }